// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content060_wrapper__X1HVl","top":"Content060_top__GLDc6","title":"Content060_title__jaIA6","description":"Content060_description__Gq1sx"};